import { Card } from 'mol-ui';
import { MethodByDay } from './MethodByDay';
import { MethodByHour } from './MethodByHour';
import { useSelector } from 'hooks';

const BY_DAY = 'by_day';
const BY_HOUR = 'by_hour';
const BY_HOUR_SCHEDULE = 'by_hour_schedule';

const AbsenceRateConfiguration = () => {

    const { configurations: { absence_rate_method } } = useSelector('configuration');

    const getAbsenceRateMethod = () => {
        switch (absence_rate_method) {
        case (BY_DAY): return <MethodByDay />;
        case (BY_HOUR): return <MethodByHour />;
        case (BY_HOUR_SCHEDULE): return <MethodByHour />;
        default: return null;
        }
    };

    return (
        <Card>
            {
                getAbsenceRateMethod()
            }
        </Card>
    );
};

AbsenceRateConfiguration.propTypes = {
    
};

export default AbsenceRateConfiguration;

